import React, {  useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next" 
import { useNavigate } from 'react-router-dom';
import { LIMIT_PAGE_SIZE, ENDPOINT } from "constants/variables";
import Box from '@mui/material/Box';  
import CircularProgress from '@mui/material/CircularProgress';  
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Textarea from '@mui/joy/Textarea';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import InputLabel  from "@mui/material/InputLabel";  
import FormControl  from "@mui/material/FormControl";  
import MenuItem  from "@mui/material/MenuItem";  
import Select  from "@mui/material/Select"; 
import "css/generalSettings.css"; 
import "css/employeeHeader.css";
import "css/customDialog.css";
import { successErrorAction,warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from 'reducers/loadingSlice';
import { LoadingNews } from "components/utils/LoadingNews"; 
import TableSortingUserAccounts from "pages/stores/storeEdit/SortingTablesUserAccount";  
import PropTypes from 'prop-types';
  
const initialStateStore = {
   "id":"",
  "documentid":"",
  "tradename":"",
  "name":"",
  "contacperson":"",
  "contacphone":"",
  "contacemail":"",
  "endpoint":"",
  "createdate":"",
  "comments":"",
  "enabled" : true,
  "useraccounts":[]
};
      
const StoreEditOrCreate = ({id, showModalStoreSettings}) => {
  const {t,i18n} = useTranslation(['listDataStores']);
  const token = useSelector((state) => state.loginUser.token); 
  const roles = useSelector((state) => state.loginUser.roles);  
  const useraccount_id = useSelector((state) => state.loginUser.useraccount_id);  
  const [formStore, setFormStore] = useState(initialStateStore);
  const isLoadingData = useSelector((state) => state.loading.isLoading);
  const [isLoadingErrorData, setIsLoadingErrorData] = useState(false);
  const [errorsStore, setErrorsStore] = useState({});
  const [foundNumberOfDocument, setFoundNumberOfDocument ]= useState(false);
  const [foundEmail, setFoundEmail ]= useState(false);
  const [valueTabs, setValueTabs] = useState("first"); 
  const [inputTextUserAccount, setInputTextUserAccount] = useState("");   
  const dispatch = useDispatch();
  const navigate = useNavigate(); 
 
  const keyPress = useCallback(
    e => {
      if (e.key === 'Escape' && showModalStoreSettings) {
        setFormStore(initialStateStore);
        setFormStore(formStore => ({
          ...formStore,
           useraccounts:[]
        })); 
        setIsLoadingErrorData(false);
        setErrorsStore({});
        setFoundNumberOfDocument(false);
        setFoundEmail(false);
        setValueTabs("first");
        setInputTextUserAccount("");    
        dispatch(setLoading(false));
        navigate("/store");
      }
    },
    [ setFormStore, 
      setIsLoadingErrorData,
      setErrorsStore,
      setFoundNumberOfDocument,
      setFoundEmail,
      setValueTabs, 
      setInputTextUserAccount,    
      showModalStoreSettings, 
      dispatch,
      navigate]
  );
  
  const handleCloseDataEditStore = () => {
    
    setFormStore(initialStateStore);
    setFormStore(formStore => ({
      ...formStore,
      useraccounts:[]
    })); 
    setIsLoadingErrorData(false);
    setErrorsStore({});
    setFoundNumberOfDocument(false);
    setFoundEmail(false);
    setValueTabs("first"); 
    setInputTextUserAccount("");    
    dispatch(setLoading(false));
    navigate("/store");
	};

  const handleChangeEnabledStore = (e) => {
    setFormStore(formStore => ({
        ...formStore,
        enabled: !formStore.enabled
    }));
  };

  const handleChangeDataEditStore = (e) => {
    const { name, value } = e.target;
    setFormStore(formStore => ({
      ...formStore,
      [name]: value,
    }));
    setFormStore(formStore => ({
      ...formStore
    }));  
  };

  const handleBlurDataEditStore = (e) => {
    handleChangeDataEditStore(e);
    setErrorsStore(validateFormStore());
  };
     
  const handleChangeValueTabs = (event,newValueTabs) => {
    setValueTabs(newValueTabs);
  };

  const filteredDataUserAccount = (formStore.useraccounts!==undefined && formStore.useraccounts!==null && formStore.useraccounts.length!==0) ? formStore.useraccounts.filter((el) => {
    if (inputTextUserAccount === '') {
        return el;
    }
    else {
      let dataTranslate = 
        String(el.id || '') +
        String(el.useraccount_username || '') +
        String(el.useraccount_firstName || '') +
        String(el.useraccount_lastName1 || '') +
        String(el.useraccount_lastName2 || '') +
        String(el.useraccount_email || '') +
        String(el.useraccount_aliasuser || '') +
        String(el.useraccount_role || '');
      let result = dataTranslate.toLowerCase().includes(inputTextUserAccount.toLowerCase());
      return result; 
    }
  }):formStore.useraccounts;

  const validateFormStore = () => {
    let errorsStore = {};
    let regexInvalidCharacters = /[\\!\\$\\%\\&\\|\\<\\>\\?\\{\\}\\~\\"\\']+/;

    if (!formStore.tradename || formStore.tradename==="") {
      errorsStore.tradename = 'Text_FieldNameRequired'; 
    } else {
      if (regexInvalidCharacters.test(formStore.tradename)) {
        errorsStore.tradename = 'Text_TextNoValid';
      }
    } 
    
    if (formStore.documentid!== undefined && formStore.documentid!==""){
      if (regexInvalidCharacters.test(formStore.documentid)) {
        errorsStore.documentid = 'Text_TextNoValid';
      }else{
        if (foundNumberOfDocument){
          errorsStore.documentid='Text_FieldnumberdocumentExist';
        }
      }
    }
   
    if (regexInvalidCharacters.test(formStore.name)) {
      errorsStore.name = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formStore.contacperson)) {
      errorsStore.contacperson = 'Text_TextNoValid';
    }
    if (regexInvalidCharacters.test(formStore.contacphone)) {
      errorsStore.contacphone = 'Text_TextNoValid';
    }
  
    if (formStore.contacemail!== undefined && formStore.contacemail!==""){
      if (regexInvalidCharacters.test(formStore.contacemail)) {
        errorsStore.contacemail = 'Text_TextNoValid';
      }else{
        if (foundEmail){
          errorsStore.contacemail='Text_FieldemailExist';
        }
      }
    }

    if (regexInvalidCharacters.test(formStore.endpoint)) {
      errorsStore.endpoint = 'Text_TextNoValid';
    }
    
    if (regexInvalidCharacters.test(formStore.comments)) {
      errorsStore.comments = 'Text_TextNoValid';
    }
 
    if (regexInvalidCharacters.test(formStore.comments)) {
      errorsStore.comments = 'Text_TextNoValid';
    }
     
    return errorsStore;
  };

  const handleSubmitDataEditStore = () => {
    const errors = validateFormStore(); 
    setErrorsStore(errors);
    if (Object.keys(errors).length === 0 && formStore.tradename !== '') {
      const fetchData = async () => {
         dispatch(setLoading(true));
        try {
          const getData = id !== "0"
            ? await helpHttp().put(ENDPOINT, `store/updatestore`, token, formStore)
            : await helpHttp().post2(ENDPOINT, `store/savestore`, token, useraccount_id, formStore);
          if (getData.status === "OK") {
            dispatch(successErrorAction(t('Text_SaveData')));
            handleCloseDataEditStore();
          } else {
            dispatch(warningErrorAction(t(getData.cause)));
          }
          dispatch(setLoading(false));
        } catch (error) {
           dispatch(setLoading(false));
          dispatch(warningErrorAction(t('Text_IncorrectData'))); 
        }  
      }; 
      fetchData();
      dispatch(setLoading(false));
    } else {
      if (errors.tradename) {
        dispatch(warningErrorAction(t(errors.tradename)));
      } else if (errors.documentid) {
        dispatch(warningErrorAction(t(errors.documentid)));
      } else if (errors.name) {
        dispatch(warningErrorAction(t(errors.name)));
      } else if (errors.contacperson) {
        dispatch(warningErrorAction(t(errors.contacperson)));
      } else if (errors.contacphone) {
        dispatch(warningErrorAction(t(errors.contacphone)));
      } else if (errors.contacemail) {
        dispatch(warningErrorAction(t(errors.contacemail)));
      } else if (errors.endpoint) {
        dispatch(warningErrorAction(t(errors.endpoint)));
      } else {
        dispatch(warningErrorAction(t('Text_IncorrectData')));
      }
    }
  };

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event && typeof event === 'object' && event.key) {
        keyPress(event);
      }
    };
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [keyPress]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistNumberDocument = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `store/getstorebynumberdocument/`, token,formStore.documentid.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setFoundNumberOfDocument(getData!==formStore.id && getData>0)
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formStore.documentid && formStore.documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistNumberDocument();
    }
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,formStore.id,formStore.documentid]);

  useEffect(() => {
    let isMounted = true;
    const fetchExistEmail = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, `store/getstorebyemail/`, token,formStore.contacemail.replace(/[.\-/\\|]/g, "").trim());
        if (getData.err) {
          dispatch(warningErrorAction(t('Text_InvalidCredentials')));
        } else if (isMounted) {
          setFoundEmail(getData!==formStore.id && getData>0)
        }
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }
    };
    if (formStore.contacemail && formStore.contacemail.replace(/[.\-/\\|]/g, "").trim()!==""){
      fetchExistEmail();
    } 
    return () => { isMounted = false };
  }, [t,token,dispatch,i18n,formStore.id,formStore.contacemail]);
  
  
  useEffect(() => {
    let isMounted = true;
    const fetchDataStore = async () => { 
      try {
        const getData = await helpHttp().get2(ENDPOINT, `store/searchstoredtobyid/`, token, id);
        if (getData.err || getData.message === "Load failed") {
          if (isMounted) {
            setFormStore(initialStateStore);
            dispatch(warningErrorAction(t(getData.message === "Load failed" ? 'Text_ConnectionFailied' : 'Text_InvalidCredentials')));
          }
        } else if (isMounted) {
          setFormStore(getData); 
        }
      
      } catch (error) {
        dispatch(warningErrorAction(t('Text_IncorrectData'))); 
      }   
    };
    if (id !== "0") {
      if (formStore.id === "") {
        fetchDataStore();
      }
    } else {
      setFormStore(initialStateStore);
      setFormStore(formStore => ({
        ...formStore, 
        useraccounts: []
      })); 
    }
    return () => { isMounted = false };

  }, [ dispatch, id, t, token, formStore.id, setFormStore,]); 
  return (
      <>
        {showModalStoreSettings ? ( 
          <div className="container-fluid formgeneral-send-wrapper">
            <Box sx={{ bgcolor: '#ffffff', width: '820px'}}>
              <form onSubmit={handleCloseDataEditStore}>  
                {/* HEADER */}
                <div className="formgeneral-card-header">
                  <div className="formgeneral-header-content">
                    <div className="formgeneral-header-title2">
                      {isLoadingErrorData?
                      <i className="fas fa-solid fa-exclamation fa-2x text-danger"/>:
                      (isLoadingData?
                      <CircularProgress sx={{ color : "#f6c23e"}}/>:
                      <i className={formStore.enabled?"fas fa-regular fa-home fa text-warning":"fas fa-regular fa-home fa text-dark"}></i>)} 
                      &nbsp;&nbsp;{formStore.tradename}
                    </div>
                    <div className="email-card-actions">
                      {!isLoadingData && (
                        <>
                          <button type="button" className="formgeneral-send-btn" onClick={handleSubmitDataEditStore} >
                            {id==="0"?t('Button_Create'):t('Button_Update')}
                          </button>
                          <button type="button" className="formgeneral-cancel-btn" onClick={handleCloseDataEditStore} >
                            {t('Button_Cancel')}
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <br/>  
                {!isLoadingData ?
                <>
                <div className="empgrid">
                    <div className="emp-col-2">
                      <div className={`empcard empcard--info ${!formStore.enabled ? "empcard--disabled empcard--strike" : ""}`}>
                        <Typography className="empcard-title">{t("Text_Id")}</Typography>
                        <Typography className="empcard-value" style={{fontSize: 26}}>
                          {id === "0" ? t("Text_New") : formStore.id}
                        </Typography>
                      </div>
                    </div>
                    {/* ===== Habilitado / Deshabilitado ===== */}
                    {roles[0].listmenus.find(k => k.name === "Handle_Store_Hability") && (
                      <div className="emp-col-3">
                        <div className="empcard empcard--info">
                          <Typography className="empcard-title">
                            {formStore.enabled ? t("Text_enabled_Upper") : t("Text_disabled")}
                          </Typography>
                          <div className="mt-8">
                            <button
                              type="button"
                              className={`empbtn empbtn-outline`}
                              onClick={handleChangeEnabledStore}
                              title={formStore.enabled ? t("Button_DISABLED") : t("Button_ENABLED")}
                            >
                              {formStore.enabled ? t("Button_DISABLED") : t("Button_ENABLED")}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}   
                    <div className="emp-col-7"> 
                    </div>
                  </div> 
                  <br/>
                  <div className="formgeneral-card-form"> 
                    <div className="row p-2"> 
                      <div className="form-group">  
                          <div className="row no-gutters align-items-center">
                              <div className="form-group">  
                                <h6 className={formStore.enabled?"h3NewStyle mb-2":"h3NewStyleDark"}>{t('Text_Personal_Data_Store')}</h6>
                                {/* Divider */}
                                <hr className="sidebar-divider d-none d-md-block"/>
                                <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_tradename')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp;   
                                <TextField
                                  id="tradename" 
                                  name="tradename"
                                  value={ formStore.tradename!== null ? formStore.tradename:""}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  inputProps={{ style: {width: i18n.language==="es"?645:623, fontSize: '18px', textDecorationLine:formStore.enabled?'none':'line-through' }, maxLength: 100, }} 
                                  label={errorsStore.tradename!=null?t(errorsStore.tradename):t('PlaceHolder_Store_tradename')}
                                  placeholder={t('PlaceHolder_Store_tradename')}
                                  variant="standard"
                                  onBlur={formStore.enabled?handleBlurDataEditStore:() => {}}
                                  onChange={formStore.enabled?handleChangeDataEditStore:() => {}}>
                                </TextField>
                                </div>
                            </div>
                            <div className="row p-2"> 
                              <div className="form-group">
                                <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_name')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp;   
                                <TextField
                                  id="name" 
                                  name="name"
                                  value={ formStore.name!== null ? formStore.name:""}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  inputProps={{ style: {width: i18n.language==="es"?604:644, fontSize: '18px', textDecorationLine:formStore.enabled?'none':'line-through' }, maxLength: 100, }} 
                                  label={errorsStore.name!=null?t(errorsStore.name):t('PlaceHolder_Store_name')}
                                  placeholder={t('PlaceHolder_Store_name')}
                                  variant="standard"
                                  onBlur={formStore.enabled?handleBlurDataEditStore:() => {}}
                                  onChange={formStore.enabled?handleChangeDataEditStore:() => {}}>
                                </TextField>
                              </div>
                            </div>
                            <div className="row p-2"> 
                              <div className="form-group">
                                <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_documentid')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="documentid" 
                                  name="documentid"
                                  value={ formStore.documentid!== null ? formStore.documentid:""}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  inputProps={{ style: {width: i18n.language==="es"?635:605, fontSize: '18px', textDecorationLine:formStore.enabled?'none':'line-through' }, maxLength: 100, }}  
                                  label={errorsStore.documentid!=null?t(errorsStore.documentid):t('Placeholder_docuemntId')}
                                  placeholder={t('Placeholder_docuemntId')}
                                  variant="standard"
                                  onBlur={formStore.enabled?handleBlurDataEditStore:() => {}}
                                  onChange={formStore.enabled?handleChangeDataEditStore:() => {}}>
                                </TextField>
                                </div>
                            </div>
                            <div className="row p-2"> 
                              <div className="form-group">
                                <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_contacperson')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp; 
                                <TextField
                                  id="contacperson" 
                                  name="contacperson"
                                  value={ formStore.contacperson!== null ? formStore.contacperson:""}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  inputProps={{ style: {width: i18n.language==="es"?675:684, fontSize: '18px', textDecorationLine:formStore.enabled?'none':'line-through' }, maxLength: 100, }}
                                  label={errorsStore.contacperson!=null?t(errorsStore.contacperson):t('Placeholder_contacperson')}
                                  placeholder={t('Placeholder_contacperson')}
                                  variant="standard"
                                  onBlur={formStore.enabled?handleBlurDataEditStore:() => {}}
                                  onChange={formStore.enabled?handleChangeDataEditStore:() => {}}>
                                </TextField>
                               </div>
                            </div>

                            <div className="row p-2"> 
                              <div className="form-group">
                                <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_phones')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp;   
                                <TextField
                                  id="contacphone" 
                                  name="contacphone"
                                  value={ formStore.contacphone!== null ? formStore.contacphone:""}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  inputProps={{ style: {width: i18n.language==="es"?670:685, fontSize: '18px', textDecorationLine:formStore.enabled?'none':'line-through' }, maxLength: 100, }} 
                                  label={errorsStore.contacphone!=null?t(errorsStore.contacphone):t('Placeholder_phone')}
                                  placeholder={t('Placeholder_phone')}
                                  variant="standard"
                                  onBlur={formStore.enabled?handleBlurDataEditStore:() => {}}
                                  onChange={formStore.enabled?handleChangeDataEditStore:() => {}}>
                                </TextField>
                                </div>
                            </div>

                            <div className="row p-2"> 
                              <div className="form-group">
                                 <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_Email')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp;   
                                <TextField
                                  id="contacemail" 
                                  name="contacemail"
                                  value={ formStore.contacemail!== null ? formStore.contacemail:""}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  inputProps={{ style: {width: i18n.language==="es"?699:699, fontSize: '18px', textDecorationLine:formStore.enabled?'none':'line-through' }, maxLength: 100, }}  
                                  label={errorsStore.contacemail!=null?t(errorsStore.contacemail):t('Placeholder_email')}
                                  placeholder={t('Placeholder_email')}
                                  variant="standard"
                                  onBlur={formStore.enabled?handleBlurDataEditStore:() => {}}
                                  onChange={formStore.enabled?handleChangeDataEditStore:() => {}}>
                                </TextField>
                                </div>
                            </div>

                            <div className="row p-2"> 
                              <div className="form-group">
                                 <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_ENDPOINT')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp;   
                                <TextField
                                  id="endpoint" 
                                  name="endpoint"
                                  value={ formStore.endpoint!== null ? formStore.endpoint:""}
                                  InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                                  inputProps={{ style: {width: i18n.language==="es"?656:656, fontSize: '18px', textDecorationLine:formStore.enabled?'none':'line-through' }, maxLength: 100, }}  
                                  label={errorsStore.endpoint!=null?t(errorsStore.endpoint):t('Placeholder_Endpoint')}
                                  placeholder={t('Placeholder_Endpoint')}
                                  variant="standard"
                                  onBlur={formStore.enabled?handleBlurDataEditStore:() => {}}
                                  onChange={formStore.enabled?handleChangeDataEditStore:() => {}}>
                                </TextField>
                              </div>
                            </div>  

                             <div className="row p-2"> 
                              <div className="form-group">
                                 <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_Bucket')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp;   
                                <FormControl variant="standard" sx={{ minWidth: i18n.language==="es"?656:656 }}>
                                  <InputLabel id="unity-label">
                                    {errorsStore.bucket != null ? t(errorsStore.bucket) : t('PlaceHolde_Buckets')}
                                  </InputLabel>
                                  <Select
                                    labelId="bucket-label"
                                    id="bucket"
                                    name="bucket"
                                    // si bucket null/undefined, usa '' para evitar el warning
                                    value={formStore.bucket ?? ""}
                                    onChange={(e) => {
                                      const v = e.target.value === '' ? "": (e.target.value);
                                      setFormStore(formStore => ({ ...formStore, bucket: v }));
                                    }}
                                  >
                                    {/* opción vacía opcional para estado no seleccionado */}
                                    <MenuItem value="">
                                      <em>{t('Text_Select')}</em>
                                    </MenuItem>
                                    <MenuItem value={"demoextran"}>DEMOEXTRANS CANARIAS, SL</MenuItem>
                                    <MenuItem value={"elbatan"}>DESGUACE EL BATÁN, S.L.</MenuItem>
                                    <MenuItem value={"ojeda"}>DAVID OJEDA CRUZ</MenuItem>
                                    <MenuItem value={"diego"}>DIEGO CRISTO CÁRDENES RODRÍGUEZ</MenuItem>
                                    <MenuItem value={"barbuzano"}>JOSÉ RAMÓN GONZÁLEZ BARBUZANO</MenuItem>
                                    <MenuItem value={"customer"}>JUAN CARLOS SÁNCHEZ MARTÍAN</MenuItem>
                                    <MenuItem value={"vega"}>JOSÉ MARIO VEGA HIDALGO</MenuItem>
                                    <MenuItem value={"bentahor"}>MANUEL ESPINO SOSA</MenuItem>
                                    <MenuItem value={"arena"}>MONTAÑA DE ARENA, S.L.</MenuItem>
                                    <MenuItem value={"gutierrez"}>TRANSPORTES GUTIERREZ GRAN CANARIA, SL</MenuItem>
                                    <MenuItem value={"trivanojeda"}>TRANSPORTES IVAN OJEDA, SL</MenuItem>
                                    <MenuItem value={"juandavid"}>TRANSPORTES JUAN DAVID SLU</MenuItem>
                                    <MenuItem value={"afonso"}>TRANSPORTES Y EXCAVACIONES AFONSO E HIJOS</MenuItem>
                                  </Select>
                                </FormControl> 
                              </div>
                            </div>  

                            <div className="row p-2"> 
                              <div className="form-group">  
                                <label className={formStore.enabled?"text-primary":"text-secondary"} style={{ fontSize: 18 }}>{t('Text_Comments')} :</label>
                                &nbsp;&nbsp;&nbsp;&nbsp;   
                                <Textarea 
                                  id="comments" 
                                  name="comments"
                                  value={formStore.comments}
                                  label={errorsStore.comments!=null?t(errorsStore.comments):t('Placeholder_Comments')}
                                  placeholder={t('Placeholder_Comments')}
                                  sx={{width: i18n.language==="es"?780:780, fontSize: 18} }
                                  variant="standard"
                                  onBlur={formStore.enabled?handleBlurDataEditStore:() => {}}
                                  onChange={formStore.enabled?handleChangeDataEditStore:() => {}}
                                  maxRows={8}
                                />  
                              </div>
                            </div>
                              
                            <div className="row p-2"> 
                              <div className="form-group"> 
                                <Box sx={{ width: '100%' }}>
                                  <Tabs
                                    value={valueTabs}
                                    onChange={handleChangeValueTabs}
                                    style={{fontSize: 18,color:formStore.enabled?"#4e73df":"#858796"}}
                                    indicatorColor="primary"
                                    variant="fullWidth"
                                    aria-label="secondary tabs example">
                                    <Tab value="first" label={t('Text_Users_Store')} style={{fontSize: 18}}/>
                                     
                                  </Tabs>  
                                </Box>
                              </div>
                            </div>
                            { valueTabs==="first"? 
                              <div className="formdi-pending-card-flat">
                                <div className="formdi-pending-card-content">  
                                  <TableSortingUserAccounts 
                                    dataUserAccounts={filteredDataUserAccount}
                                    checkedRow={formStore.enabled}
                                    numTotRegUserAccount={formStore.useraccounts!==null?formStore.useraccounts.length:0}
                                    setInputTextUserAccount={setInputTextUserAccount}
                                    LIMIT_PAGE_SIZE={LIMIT_PAGE_SIZE}
                                  />
                                  
                                </div>
                              </div>
                            :valueTabs==="five" &&
                              <div className="row p-2">  
                              </div> 
                            }
                          </div>
                        
                    </div>
                </div>
              </>:
                <LoadingNews/> 
            }
            </form>
          </Box>
          <br/> 
        </div>
      //* End Page Content *//
    ) :  null }
  </>
  )    
}

StoreEditOrCreate.propTypes = {
  id: PropTypes.string.isRequired,
  showModalStoreSettings: PropTypes.bool.isRequired
};

export default StoreEditOrCreate;